import _ from 'lodash';
import { DateTimeRange } from '@skyjs/date';
import isDateRangeExpressionValueValid from '../isDateRangeExpressionValueValid.js';

export default getQueryExpression => ({
  getPathExpression: (path, value) => {
    if (!isDateRangeExpressionValueValid('DateTimeRange', value)) {
      throw new Error(`Invalid DateTimeRange value: ${value}`);
    }

    const expression = Function('DateTimeRange', `return ${value};`)(DateTimeRange);
    const criteria = _.isArray(expression)
      ? _.set(
          {},
          '$or',
          expression.map(e => ({ [path.join('.')]: e }))
        )
      : _.set({}, path.join('.'), expression);

    return getQueryExpression(criteria);
  }
});
